// src/routes/rootRoute.jsx
import { Navigate } from 'react-router-dom';

export const rootRoute = {
  path: '/',
  element: <Navigate to="/login" replace />
};